import script from "./ProductionPipeline.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionPipeline.vue?vue&type=script&setup=true&lang=js"

import "./ProductionPipeline.vue?vue&type=style&index=0&id=c0df8196&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0df8196"]])

export default __exports__